"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProprietaryTimerTypeSchema = void 0;
const zod_1 = require("zod");
exports.ProprietaryTimerTypeSchema = zod_1.z.custom((val) => /^TIMER_\d+$/g.test(val));
